import React, { Component } from 'react';
import { IosToggle, FlipToggle, SkewToggle } from 'reacttoggles'
import { Tabs, Tab } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'

const components = {
    IosToggle,
    FlipToggle,
    SkewToggle
}

const iframes = [
    `//codepen.io/nerdchacha/embed/YZEKvm/?height=400&theme-id=dark&default-tab=js&embed-version=2`,
    `//codepen.io/nerdchacha/embed/RpjbBw/?height=400&theme-id=dark&default-tab=js&embed-version=2`,
    `//codepen.io/nerdchacha/embed/PpOYBZ/?height=400&theme-id=dark&default-tab=js&embed-version=2`,
]

class Checked extends Component {
    render() {
        return (
            <Tabs defaultActiveKey={0} id="uncontrolled-tab-example" className="card" >
                {Object.keys(components).map((key, i) => (
                    <Tab eventKey={i} key={i} title={key}>
                        {
                            React.createElement(components[key], {
                                onProps: {component: (<FontAwesome name='check' />)},
                                offProps: {component: (<FontAwesome name='times' />)}
                            })
                        }
                        <iframe
                            height='265'
                            scrolling='no'
                            title='aJyPJy'
                            src={iframes[i]}
                            frameBorder='no'
                            allowTransparency='true'
                            allowFullScreen='true'
                            >
                        </iframe>
                    </Tab>
                ))}
                <p><strong>NOTE:</strong> The toggle width is not dynamic and will not handle long string values gracefully. Use this options wisely</p>
                <p>Make sure to include fontawesome css if you are using <code>react-fontawesome</code></p>
            </Tabs>
        );
    }
}

export default Checked;



// WEBPACK FOOTER //
// ./src/components/OnOffIcon.js